import { ELEMENT_TYPE } from "types/ReportingDashboard/elements.types"
/**
 * Creates a unique slide ID using timestamp and random number.
 */
export const createSlideId = (): string => {
  return `slide_${Date.now()}_${Math.floor(Math.random() * 1000)}`
}

/**
 * Creates a unique template ID using timestamp and random number.
 */
export const createTemplateId = (): string => {
  return `template_${Date.now()}_${Math.floor(Math.random() * 1000)}`
}

/**
 * Generates a unique ID for a new reporting element.
 * Combines type, timestamp, and random string for better uniqueness.
 */
export const createElementId = (
  type: ELEMENT_TYPE = ELEMENT_TYPE.DEFAULT
): string => {
  return `${type}_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`
}

/**
 * Generates a unique table ID for engine scripts based on the element ID
 * Ensures each element gets its own namespace for tables/charts in the engine
 *
 * @param {string} elementId - The ID of the element/component
 * @returns {string} A unique table ID for use in engine scripts
 */
export const generateUniqueTableId = (elementId: string): string => {
  // Clean the elementId to make it suitable for the engine script
  // Remove non-alphanumeric characters and convert to lowercase
  const cleanedId = String(elementId)
    .replace(/[^a-zA-Z0-9]/g, "")
    .toLowerCase()

  // Create a table ID with a prefix to avoid potential conflicts
  return `tbl_${cleanedId}`
}
